import React from "react";
import { Alert, Form, Input, Button, Row, Col } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import { drugSentToPatientRequest } from "../../api/requests";

import classes from "./SendToPatientForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

class SendToPatientForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          await drugSentToPatientRequest(get(this.props.drug, "id"), values);
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit();
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { drug } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t("NamespaceSendToPatientForm:Set tracking")}
          </h4>

          <h5 className="headline-default">
            {this.props.i18n.t("Patient")}: {get(drug, "subject.code")}
          </h5>
          <p>
            {get(drug, "subject.profile.last_name") && (
              <div>
                {this.props.i18n.t("Patient")}:{" "}
                {get(drug, "subject.profile.first_name")} (
                {get(drug, "subject.profile.last_name")})<br />
              </div>
            )}
            {get(drug, "subject.profile.phone_number_1") && (
              <div>
                {this.props.i18n.t("Phone")}:{" "}
                {get(drug, "subject.profile.phone_number_1")} <br />
              </div>
            )}
            {get(drug, "subject.profile.street_address") && (
              <div>
                {this.props.i18n.t("NamespaceSendToPatientForm:Street address")}
                : {get(drug, "subject.profile.street_address")}
                <br />
              </div>
            )}
            {get(drug, "subject.profile.province") && (
              <div>
                {this.props.i18n.t("NamespaceSendToPatientForm:Province")}:{" "}
                {get(drug, "subject.profile.province")}
                <br />
              </div>
            )}
            {get(drug, "subject.profile.city") && (
              <div>
                {this.props.i18n.t("NamespaceSendToPatientForm:City")}:{" "}
                {get(drug, "subject.profile.city")}
              </div>
            )}
          </p>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t("NamespaceSendToPatientForm:Tracking")}:
                </b>
                <Form.Item>
                  {getFieldDecorator("tracking", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(<Input />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
              >
                {this.props.i18n.t("Save")}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (_) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "drugShip" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SendToPatientForm))
);



// WEBPACK FOOTER //
// ./src/components/SendToPatientForm/SendToPatientForm.js